import { createStore, combineReducers } from 'redux';
import storeReducer from '../reducers/storeReducer';
import profileReducer from '../reducers/profileReducer';
const rootReducer = combineReducers(
    { store: storeReducer, profile_data: profileReducer}
);
const configureStore = () => {
    return createStore(rootReducer);
}
export default configureStore;